import { TagSchema } from '../hooks/use-tag-schema';

export const buttonStyle = (schema: TagSchema) => {
	return {
		_active: {
			bg: schema.activeBg,
			color: schema.activeText,
		},
		_disabled: {
			bg: schema.activeBg,
			color: schema.activeText,
			cursor: 'not-allowed',
		},
		_hover: {
			bg: schema.activeBg,
			color: schema.activeText,
		},
	};
};
